import { render, staticRenderFns } from "./Docu.vue?vue&type=template&id=ab810f44&scoped=true&"
import script from "./Docu.vue?vue&type=script&lang=js&"
export * from "./Docu.vue?vue&type=script&lang=js&"
import style0 from "./Docu.vue?vue&type=style&index=0&id=ab810f44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab810f44",
  null
  
)

export default component.exports